import { useState } from "react";
import { Container } from "reactstrap";
import AppNavbar from "../../AppNavbar/AppNavbar";
import FieldTypeCalculated from "./FieldTypeSpecific/FieldTypeCalculated";
import { isEmpty } from "underscore";

type Tabs = "static" | "calculated";
interface DefaultValueTypeSelectorI {
  onChange: (val: any) => void;
  fieldValues: any;
  component: any;
}

export default function DefaultValueTypeSelector({
  onChange,
  fieldValues,
  component,
}: DefaultValueTypeSelectorI) {
  const [tab, setTab] = useState<Tabs>(
    fieldValues?.calculatedFieldData &&
      !isEmpty(fieldValues?.calculatedFieldData)
      ? "calculated"
      : "static"
  );

  const tabs = [
    {
      title: "Static",
      activeValue: "static",
    },
    {
      title: "Calculated",
      activeValue: "calculated",
    },
  ];

  const handleTabChange = (val: Tabs) => {
    setTab(val);
  };

  const output = {
    Currency: "currency",
    Number: "number",
    CurrencyInterval: "currency",
    Percent: "percentage",
  };

  return (
    <Container fluid>
      <div className="mt-1 pb-4">
        {/* @ts-ignore */}
        <AppNavbar tabs={tabs} activeTab={tab} onSelect={handleTabChange} />
      </div>
      {tab === "static" && <>{component}</>}
      {tab === "calculated" && (
        <>
          <FieldTypeCalculated
            fieldValues={fieldValues}
            setFieldValues={onChange}
            defaultType="number"
            // @ts-ignore
            defaultOutput={output[fieldValues?.fieldType]}
            disabledSelection
            fieldToIgnore={fieldValues?.apiName}
            styles="mt-1"
          />
        </>
      )}
    </Container>
  );
}
